import React, { useContext, useState, useEffect } from "react";
import usePuntosVenta from "../../hooks/usePuntosVenta";
import PuntosVentas from "../puntosVentas/PuntosVentas";
import { Spinner, AuthContext } from "../shared";
import { BotonAgregar } from "../shared/Estilos";
import { Input } from "../shared/FormsElements";
import ListarUsuarios from "./ListarUsuarios";
import Tabla from "./tablas/Tabla";
import "../shared/styles/ViewContainer.css";

const Usuarios = (props) => {
  const authContext = useContext(AuthContext);
  const { usuarios, cargando, obtenerUsuariosII } = authContext;

  const [steps, setSteps] = useState(0);
  const [DatosForm, LeerForm] = useState({ buscar: "" });

  const { buscar } = DatosForm;

  const onChange = (e) => {
    LeerForm({
      ...DatosForm,
      [e.target.name]: e.target.value,
    });

    if (buscar.length > 1) {
      obtenerUsuariosII(buscar);
    }
  };

  useEffect(() => {
    obtenerUsuariosII(buscar);
  }, [buscar]);


  //Parametros
  const [params, setParams] = useState({
    url: "PuntosDeVenta/index",
    id: "",
  });

  //Consultas Api
  const { puntoVenta_data, puntoVenta_isLoading, puntoVenta_message } =
    usePuntosVenta(params.url, params, steps);
  return (
    <div className="view-container">
      <div className="view-header">
        <h1 className="view-title">Gestionar Usuarios</h1>
        <div className="view-toolbar">
          <button
            onClick={() => props.history.push("/usuarios/nuevo")}
            className="btn-add-primary"
          >
            <i className="fa fa-plus-circle"></i>
            Agregar Usuario
          </button>

          <div className="search-input-container">
            <input
              type="text"
              name="buscar"
              className="search-input"
              placeholder="Buscar usuario por nombre, email..."
              value={buscar}
              onChange={onChange}
            />
            <i className="bi bi-search search-icon"></i>
          </div>
        </div>
      </div>

      { cargando ? <Spinner /> : <Tabla data={usuarios} puntoVenta={puntoVenta_data} setSteps={setSteps} steps={steps} /> }

      {/* cargando ? <Spinner /> : <ListarUsuarios usuarios={usuarios} /> */}


      <PuntosVentas data={puntoVenta_data} params={params} setParams={setParams} />

    </div>
  );
};

export default Usuarios;
